import { http } from '../../utils/http'

export const CRMBASE = window.$envUtils('VUE_APP_CRM_SERVICE')
export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')

// 删除客户关联标签
export const delCustomerLabel = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`${CRMBASE}/customer-label/delete`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 分页查询标签ids
export const getLabelList = (data) => {
  return http(`${CRMBASE}/label/listLabels`, {
    method: 'POST',
    data
  })
}

// 查询全部标签
export const getAllLabelList = (data) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/label/listAllLabels`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 保存客户关联标签
/**
 * customerLabelReq {
 * customerId 客户id
   labelIds []
  }
 */
export const saveCustomerLabel = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/customer-label/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 更新客户信息
export const saveClient = (data) => {
  return new Promise((resolve, reject) => {
    http.put(`${CRMBASE}/customer`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取访客轨迹
export async function getVisitorStepList(params) {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/data/session_log/get`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取访客轨迹详情
export async function getChatLog(params) {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/data/chat_log/get`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
